export function initTabs(container = document) {
  container.querySelectorAll('.tabs').forEach(tabsContainer => {
    const tabs = Array.from(tabsContainer.querySelectorAll('[role="tab"]'));
    const panels = tabsContainer.querySelectorAll('.tabs__panel');

    // Fonction pour activer un tab spécifique
    function activateTab(tabIndex) {
      // Désactiver tous les onglets
      tabs.forEach((t, index) => {
        t.setAttribute('aria-selected', index === tabIndex ? 'true' : 'false');
        t.classList.toggle('active', index === tabIndex);
        t.setAttribute('tabindex', index === tabIndex ? '0' : '-1'); // Seul l'actif est focusable
      });

      // Masquer tous les panels et les rendre inertes
      panels.forEach(panel => {
        panel.classList.remove('active');
        panel.style.overflow = 'hidden';
        panel.setAttribute('inert', '');
        const firstChild = panel.firstElementChild;
        if (firstChild) {
          firstChild.style.overflow = 'hidden';
        }
      });

      // Afficher le panel correspondant et retirer inert
      const activeTab = tabs[tabIndex];
      const panelId = activeTab.getAttribute('aria-controls');
      const panel = tabsContainer.querySelector(`#${panelId}`);
      if (panel) {
        panel.classList.add('active');
        panel.removeAttribute('inert');

        // Attendre la durée de la transition CSS avant de remettre overflow visible
        const duration = parseFloat(getComputedStyle(panel).transitionDuration) * 1000 || 300;
        setTimeout(() => {
          panel.style.overflow = 'visible';
          const firstChild = panel.firstElementChild;
          if (firstChild) {
            firstChild.style.overflow = 'visible';
          }
        }, duration);
      }
    }

    // Initialiser : activer le premier tab par défaut
    // Onglet actif du markup (aria-selected="true" ou .active), sinon le premier
    const initial = tabs.findIndex(t => t.getAttribute('aria-selected') === 'true' || t.classList.contains('active'));
    if (tabs.length) activateTab(initial >= 0 ? initial : 0);

    // Ajouter les event listeners
    tabs.forEach((tab, index) => {
      // Clic souris (gardé pour compatibilité)
      tab.addEventListener('click', () => {
        activateTab(index);
      });

      // Navigation clavier
      tab.addEventListener('keydown', (event) => {
        let newIndex = index;
        switch (event.key) {
          case 'ArrowLeft':
            newIndex = index > 0 ? index - 1 : tabs.length - 1; // Navigation circulaire
            break;
          case 'ArrowRight':
            newIndex = index < tabs.length - 1 ? index + 1 : 0; // Navigation circulaire
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = tabs.length - 1;
            break;
          case 'Enter':
          case ' ':
            // Activer le tab (déjà fait, mais pour clarté)
            activateTab(index);
            event.preventDefault(); // Empêcher le scroll pour Espace
            return;
          default:
            return; // Ignorer les autres touches
        }
        event.preventDefault();
        activateTab(newIndex);
        tabs[newIndex].focus(); // Mettre le focus sur le nouveau tab
      });
    });
  });
}